import { useFormContext } from 'contexts/FormContext';
import LoadingIndicator from 'components/LoadingIndicator';
import CurrentStep from 'components/CurrentStep';
import NextStepButton from 'components/NextStepButton';
import Header from 'components/Header';
import { steps } from 'utils/steps';

/**
 * The main form component that manages the creation of a new project.
 * It renders different form steps based on the current step value,
 * a loading indicator when loading, and a next step button.
 *
 * @returns {React.Component} The CreateProjectForm component.
 */
const CreateProjectForm = () => {
  const {
    loading,
    currentStep,
    handleNextStepButtonClick,
    handleSubmitButtonClick,
  } = useFormContext();

  if (loading) {
    return <LoadingIndicator />;
  }

  const isLastStep = !steps[currentStep + 1];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isLastStep) {
      handleSubmitButtonClick();
    } else {
      handleNextStepButtonClick();
    }
  };

  return (
    <form className='container' onSubmit={handleSubmit} noValidate>
      <Header />
      <CurrentStep currentStep={currentStep} />
      <NextStepButton />
    </form>
  );
};

export default CreateProjectForm;
